import { Component, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import { DatePipe } from '@angular/common';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-cannot-login',
  templateUrl: './cannot-login.component.html',
  styleUrls: ['../../assets/layout/style/layout.css','./cannot-login.component.css' ]
})

export class CannotLoginComponent implements OnInit {
  types = [];
  userform: FormGroup;
  submitted: boolean;
  items: any[];
  countryTitle: string;
  selectedCity: string;
  phoneTitle: string;
  emailTitle: string;
  dpiTitle: string;
  loginBtnTitle: string;
  fcmToken: string;
  masks = 'dd/MM/yyyy';
  selectedType = 0;
  sessionResponse: any;
  yearRange: string;
  product: any = [];
  selectedProducts: any[];
  blob:any = [];
  env = environment;
  @ViewChild('fileUpload') fileUpload: any;
  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private Rc: FirebaseService, private fb: FormBuilder, private auth: AuthService,
              private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private dp: DatePipe) {
  }

  ngOnInit() {
    
    this.yearRange = `${new Date().getFullYear() - 120}:${new Date().getFullYear()}`;
    this.types = [];
    this.types.push({ label: 'Actualizar Datos', value: 0 });
    this.types.push({ label: 'Sesiones Activas', value: 1 });
    
    this.Rc.fetchActivate().then(() => {
      console.log('pais:::::: ', this.Rc.getStringRC('global_select_country_title'));
      this.phoneTitle = this.Rc.getStringRC('global_phone_number');
      this.dpiTitle = this.Rc.getStringRC('global_number_id');
      this.emailTitle = this.Rc.getStringRC('global_email_address');
      this.loginBtnTitle = this.Rc.getStringRC('global_accept');
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
    });
    
    this.realm.getCountriesArea().then((data:any) => {
      this.items = data.data.countryCodeAppSettingsOrms;
    })
    
    this.userform = this.fb.group({
      phoneNumber: new FormControl('', [Validators.required, Validators.minLength(4)]),
      dpi: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      birthdate: new FormControl('', Validators.required),
      id: new FormControl('', Validators.required)
    });
    this.selectedCity = this.userform.get('country').value;
  }
  ngAfterViewInit() {
    console.log("afterViewInit");
    

    this.api.responseApiCannotLogin$
      .subscribe(data => {
        console.log('data ws: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        if (data !== undefined) {
          this.env.isContentLoading = false;
        }
        if (dat.code === 701) {
          this.messageService.add({severity: 'success', summary: 'Exito', detail: 'Datos Actualizados exitosamente...', sticky: false});
          this.setvalues();
          //this.router.navigate(['/login']);
        } else {
          // tslint:disable-next-line:max-line-length
          this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.code), sticky: false});
        }
      });
  }

  formatDates(items:any) {
    items.map( (item:any) => {
      if (item.logs[0].date !== undefined) {
        let myDatePayment = item.logs[0].date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");
        item.logs[0].date = this.dp.transform(myDatePayment, 'yyyy-MM-ddThh:mm', 'es-ES');
      }
    });
    this.sessionResponse = items;
    console.log("---- response ws: ----LIMPIO  ",this.sessionResponse);
  }

  test(event: any) {
    this.selectedType = event.option.value;
    if (this.selectedType === 1) {
      this.realm.getSessionSettings();
    }
  }
  setvalues() {
    const t =  this.items[0];
    this.fileUpload.clear();
    this.userform.reset();
  }
  onSubmit(value: string) {
    this.env.isContentLoading = true;
    this.submitted = true;
    const q = JSON.parse(JSON.stringify(value));
    console.log(q);
    let documentId = q.dpi;
    let email = q.email;
    let phoneNumber = q.country.idCode + "" + q.phoneNumber;
    let portalAllowed = "RPN";
    let birthdate = q.birthdate;
    let completeName = q.name;
    let policyCardNumber = q.id;
    this.realm.cannotLoginPost(documentId, email, phoneNumber, portalAllowed, birthdate, completeName, policyCardNumber, this.blob);
    
  }

  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})/, '$1/$2/');
    //console.log(event.target.value);
  }

  async myUploader(event) {
    //event.files == files to upload
    let arr:any[];
    let base64:any;
    let fileReader;
    var file = event.files;
    let this2 = this;
    file.map((fl) => {
      fileReader = new FileReader();
      fileReader.readAsDataURL(fl);
      fileReader.onload = (() => {
          // Will print the base64 here.
          //console.log(fileReader.result.toString().split(",")[1]);
          //console.log(fileReader.result);
          //base64 = fileReader.result.toString().split(",")[1];
          this.blob.push(fileReader.result.toString().split(",")[1]);
      });
    })
    
    setTimeout(() => {
      this.blob.map(file => {
        console.log("file::::: "+ file);
      })
      //console.log("this.blob: "+ this.blob);
      console.log("size: "+ this.blob.length);
      /*this.realm.loadProfileImage("perfil.png", this.blob).then(() => {
        this.realm.getProfileImage();
        this.messageService.add({severity: 'info', summary: 'Carga satisfactoria', detail: 'Imagen cargada con éxito'});
      });*/
    }, 200)
    
  }

  validate(evt) {
    var theEvent = evt || window.event;
    // Handle paste
    if (theEvent.type === 'paste') {
        //key = event.clipboardData.getData('text/plain');
    } else {
    // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if( !regex.test(key) ) {
      theEvent.returnValue = false;
      if(theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  onChange(event) {
    // Get your files
    const files: FileList = event.target.files;
  
    // Clear the input
    event.target.value = null;
  }
}

